// Super-admin (Foundry-team) cross-tenant endpoints.
// Backed by /api/super/* — caller must be an OWNER of foundry-self.

import { api } from "./client";

export interface SuperTenantRow {
  slug: string;
  display_name: string;
  domain: string | null;
  status: string;
  current_spec_hash: string | null;
  created_at: string;
}

export const listSuperTenants = (): Promise<SuperTenantRow[]> =>
  api("/api/super/tenants");

export interface SuperTenantDetail extends SuperTenantRow {
  application_name: string;
  primary_color: string;
  secondary_color: string | null;
  logo_url: string | null;
}

export const getSuperTenant = (slug: string): Promise<SuperTenantDetail> =>
  api(`/api/super/tenants/${slug}`);
